// File: Login.jsx
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FaGithub } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import api from "../Utils/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import Spinner from "../Components/Spinner";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!email || !password) {
      toast.info("Please fill in all fields");
      setIsLoading(false);
      return;
    }
    
    // Try user login first
    let res = await api.post("/user/login", { email, password, web: true });
    
    // If user login fails, try location login
    if (!res.data.success) {
      res = await api.post("/location/login", { username: email, password });
    }
    
    setIsLoading(false);
    if (res.data.success) {
      toast.success(res.data.message || "Login successful");

      localStorage.setItem("token", res.data.token);
      let decoded = jwtDecode(res.data.token);
      dispatch({ type: "SET_USER", payload: decoded });
      
      // Redirect location-based logins to Scan Events page
      if (decoded.loginType === "location") {
        navigate("/scanevents");
      } else {
        navigate("/");
      }
    } else {
      toast.error(res.data.message || "Invalid login credentials");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white relative px-4">
      {isLoading && <Spinner />}

      {/* Content Wrapper */}
      <div className="relative z-10 flex flex-col -mt-24 items-center w-full">
        {/* Title */}
        <div className="mb-10">
          <h1 className="font-extrabold text-[30px] md:text-5xl text-[#0a2449] text-center tracking-wide">
            WorkTime Admin Panel
          </h1>
        </div>

        {/* Login Card */}
        <div className="w-full max-w-md rounded-xl shadow-lg bg-white p-8 border border-gray-200">
          <h2
            className="text-3xl font-bold text-gray-700 mb-6"
            style={{ fontFamily: "Righteous, sans-serif" }}
          >
            Login
          </h2>
          <form onSubmit={handleLogin} className="space-y-5 text-gray-700">
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-1">
                Email address-
              </label>
              <input
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                className="w-full px-4 py-2 rounded-md border border-gray-300 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
                required
                autoComplete="email"
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium mb-1"
              >
                Password
              </label>
              <input
                onChange={(e) => setPassword(e.target.value)}
                id="password"
                type="password"
                className="w-full px-4 py-2 rounded-md border border-gray-300 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
                required
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              className="w-full py-2 rounded-md font-semibold transition bg-gray-600 text-white hover:bg-gray-700"
            >
              Sign in
            </button>
          </form>
          
          {/* Register Link */}
          <div className="mt-6 text-center">
            <p className="text-gray-600 text-sm">
              Don't have an account?{" "}
              <button
                onClick={() => navigate("/register")}
                className="text-gray-600 hover:text-gray-800 font-semibold underline transition-colors"
              >
                Sign up here
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
